import { useAsyncExecutor2, useAsyncExecutorPool } from "async-executor-hook";
import { useEffect } from "react";
import { Route, Switch } from "react-router-dom";

import { HTTP_METHODS } from "../../utils/constants";
import { networkBackendRequest } from "../../utils/networkUtils";
import { USER_ROUTES } from "../../utils/routeConstants";
import Billing from "../Billing/Billing";
import ChatbotScreen from "../ChatbotScreen/ChatbotScreen";
import ComplaintStatus from "../ComplaintsStatus/ComplaintsStatus";
import CreateComplaint from "../CreateComplaint/CreateComplaint";
import DocumentManagement from "../DocumentManagement/DocumentManagement";
import UsersManagementResource from "../UsersManagement/UsersManagementResource";
import { ContainerAgent } from "./AdminDocumentManagementScreenStyles";

const AgentRoutesManagementScreen = (props: any) => {
  const { userCompanyMe, userProfileMe, userInfo } = props;
  const asyncExecutorPool = useAsyncExecutorPool("");
  const asyncExecutorPoolRolProcesses = useAsyncExecutorPool("");

  const loadRolProfiles = useAsyncExecutor2(
    () => {
      return networkBackendRequest(`/roles/`, HTTP_METHODS.GET, {}).then(
        (response) => response.json()
      );
    },
    {
      cache: true,
      onSuccess: () => {},
    }
  );

  const loadRolProcesses = useAsyncExecutor2(
    () => {
      return networkBackendRequest(`/processes/`, HTTP_METHODS.GET, {}).then(
        (response) => response.json()
      );
    },
    {
      cache: true,
      onSuccess: () => {},
    }
  );

  useEffect(() => {
    asyncExecutorPool.addExecutor("loadRolProfilesUserAgent", loadRolProfiles);
    asyncExecutorPoolRolProcesses.addExecutor(
      "loadRolProcessesUserAgent",
      loadRolProcesses
    );
    if (userInfo.profile.name === "Administrador") {
      loadRolProfiles.execute({});
      loadRolProcesses.execute({});
    }
    // eslint-disable-next-line
  }, [userInfo]);

  return (
    <ContainerAgent>
      <Switch>
        <Route path={USER_ROUTES.BILLING_USERS_AGENT.path}>
          <Billing userInfo={userInfo} />
        </Route>
        <Route path={USER_ROUTES.DOCUMENT_VALIDATION.path}>
          <DocumentManagement userInfo={userInfo} />
        </Route>
        <Route path={USER_ROUTES.COMPLAINTS.path}>
          <ComplaintStatus />
        </Route>
        <Route path={USER_ROUTES.CHATBOT.path}>
          <ChatbotScreen />
        </Route>
        <Route path={USER_ROUTES.CREATE_COMPLAINTS.path}>
          <CreateComplaint />
        </Route>
        <Route path={USER_ROUTES.USER_AGENT.path}>
          <UsersManagementResource
            userCompanyMe={userCompanyMe}
            userProfileMe={userProfileMe}
            userInfo={userInfo}
          />
        </Route>
      </Switch>
    </ContainerAgent>
  );
};
export default AgentRoutesManagementScreen;
